<script>
import TheHeaderTableUmuSection from "../components/UMUPage/TheHeaderTableUmuSection.vue";
import TheFilterTeachersListDialog from "../../Dialog/TheFilterTeachersListDialog.vue";
import SubTableEffContract from "../components/UMUPage/SubTableEffContract.vue";
import TheEditTeacherOrderDialog from "../../Dialog/TheEditTeacherOrderDialog.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import ApiServices from "../../services/api.services";
import Loading from "../Loading.vue";
import EffContractUMUDetailDialog from "../components/UMUPage/EffContractUMUDetailDialog.vue";
import EffContractUmuCommentFormDialog from "../components/UMUPage/EffContractUmuCommentFormDialog.vue";
import TheEffContractUmuTableColumnFullName from "../components/UMUPage/TheEffContractUmuTableColumnFullName.vue";

export default {
  name: "EffectiveContractUMUPage",
  components: {
    TheEffContractUmuTableColumnFullName,
    EffContractUmuCommentFormDialog,
    EffContractUMUDetailDialog,
    Loading,
    TheEditTeacherOrderDialog,
    SubTableEffContract,
    TheFilterTeachersListDialog,
    TheHeaderTableUmuSection
  },

  data() {
    return {
      expanded: [],
      singleExpand: true,
      search: "",
      loadingContracts: false,
      arraysFilters: [],
      showFilterDialog: false,
      isFilteredList: false,
      currentOrder: {},
      selectedTeachers: [],
      showEditOrderDialog: false,
      loading: true,
      headersTeacher: [
        {
          text: 'ФИО', value: 'full_name', groupable: false, sortable: false, class: "text-subtitle-1",
        },
        {
          text: 'Должность', value: 'teacher_eff_order.academic_title', groupable: false, sortable: false, class: "text-subtitle-1"
        },
        {
          text: 'Ставка', value: 'teacher_eff_order.bid', groupable: false, sortable: false, class: "text-subtitle-1"
        },
        {
          text: 'Зав. кафедрой', value: 'teacher_eff_order.head_department', groupable: false, sortable: false, class: "text-subtitle-1"
        },
        {
          text: 'Декан', value: 'teacher_eff_order.dean', groupable: false, sortable: false, class: "text-subtitle-1"
        },
        {
          text: 'Проверка', value: 'progress', groupable: false, sortable: false, class: "text-subtitle-1"
        },
        { text: 'Действие', value: 'action', groupable: false, sortable: false,},
      ],

      effContractDetailDialog: false,
    }
  },

  async mounted() {
    try {
      await this.getTeacherList();
    }catch (err) {
      console.warn(err)
    }
    this.loading = false;
  },

  computed: {

    ...mapState({
      teachersList: state => state.effective_contract.teachersList,
    }),

  },

  methods: {
    ...mapMutations({
      setTeachersList: "effective_contract/setTeachersList",
    }),

    ...mapActions({
      getTeacherList: "effective_contract/getTeacherList",
    }),

    fullName(person) {
      try {
        let fullName = person.surname + " " + person.name[0] + "."
        if (person?.patronymic !== null && person?.patronymic !== "") {
          fullName += person.patronymic[0] + "."
        }
        return fullName
      } catch (e) {
        console.log(e);
        console.log(person)
      }
    },

    async filteredListTeachers(listNames, confirmContracts) {
      if (listNames.length === 0) {
        this.arraysFilters = [];
        return this.getTeacherList();
      }

      const arrayNames = _.map(listNames, (o) => {return o.indicator_name});
      try {
        const response = await ApiServices.filteredListPerson(arrayNames, confirmContracts);
        this.arraysFilters = listNames;
        this.setTeachersList(response.data.teachers_list);
      } catch (e) {
        console.log(e);
      }

    },

    colorProgress(item) {
      if (item.teacher_eff_order.is_sent_review) {
        if (item.progress >= 100) return "#05fa1d"
        else return "yellow darken-4"
      } else {
        return ""
      }
    },

    calculateProgress(contracts, effOrder, allEffOrder) {
      const indexOrder = _.indexOf(allEffOrder, effOrder);
      const personEffContractsSize = allEffOrder[indexOrder].person_eff_contracts_size;
      if (personEffContractsSize === 0) return 0.00

      const confirmedContracts = _.filter(contracts, (o) => o.status !== 'not_confirm').length;

      this.$set(allEffOrder[indexOrder], 'person_eff_contracts_confirmed_size', confirmedContracts);
      this.$set(allEffOrder[indexOrder], 'progress', (confirmedContracts/personEffContractsSize * 100).toFixed(2));
    },

    openEffContractDetailDialog(order) {
      this.currentOrder = order;
      this.effContractDetailDialog = true;
    },

    closeEffContractDetailDialog(personEffContracts) {
      this.calculateProgress(personEffContracts, this.currentOrder, this.teachersList)
      this.currentOrder = {};
      this.effContractDetailDialog = false;
    },

    subtitleStatusOrder(teacher) {
      if (_.isNull(teacher)) return undefined;

      const isReview = teacher.teacher_eff_order.is_sent_review;
      const progress = teacher.progress;

      if (isReview && progress < 100) return "Отправлено на проверку"
      if (isReview && progress >= 100) return "ЭК проверен"
      return "В процессе заполнения"
    },

  },
}
</script>

<template>
  <loading :loading="loading">
    <v-sheet>

      <eff-contract-u-m-u-detail-dialog
        :dialog="effContractDetailDialog"
        @close="closeEffContractDetailDialog"
        :eff-con-order="currentOrder"
      />

      <v-card-title>Раздел УМУ</v-card-title>
      <v-data-table
        :headers="headersTeacher"
        :items="teachersList"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        :search="search"
        loading-text="Идет загрузка списка, подождите..."
        item-key="id"
        show-select
        v-model="selectedTeachers"
        :single-select="false"
        no-data-text="Список пуст"
        sort-by="progress"
        :footer-props="{
          prevIcon: 'fa-chevron-circle-left',
          nextIcon: 'fa-chevron-circle-right',
          itemsPerPageText: 'Количество строк на страницу',
          itemsPerPageOptions: [8,12,16],
          showCurrentPage: true,
        }"
      >
        <template #top>
          <the-header-table-umu-section
            :teachers-list="selectedTeachers"
            @search="search = $event"
            @filter="showFilterDialog = true"
            :array-filters="arraysFilters"
            @clear-filter="arraysFilters = []"
            @editOrder="showEditOrderDialog = true"
            @clearSelectedTeachers="selectedTeachers = []"
          />
          <v-divider/>
        </template>

        <template #item.full_name="{item}">
          <the-eff-contract-umu-table-column-full-name
            :progress="item.progress"
            :status="item.teacher_eff_order.is_sent_review"
            :full-name="item.full_name"
          />
        </template>

        <template #item.teacher_eff_order.bid="{item, index}">
          <v-chip small v-if="item.teacher_eff_order.bid === 1">
            Полная
          </v-chip>
          <v-chip small v-else>
            {{'Не полная (' + item.teacher_eff_order.bid + ')'}}
          </v-chip>
        </template>

        <template #item.teacher_eff_order.head_department="{item, index}">
          <v-icon
            small
            :color="item.teacher_eff_order.head_department ? 'teal darken-3' : 'error'"
          >
            {{item.teacher_eff_order.head_department ? 'fa-check-circle' : 'fa-times-circle'}}
          </v-icon>

          <v-icon>

          </v-icon>
        </template>

        <template #item.teacher_eff_order.dean="{item, index}">
          <v-icon
            small
            :color="item.teacher_eff_order.dean ? 'teal darken-3' : 'error'"
          >
            {{item.teacher_eff_order.dean ? 'fa-check-circle' : 'fa-times-circle'}}
          </v-icon>
        </template>

        <template #item.progress="{item, index}">
          <v-chip
            outlined
            :color="colorProgress(item)"
          >
            <v-icon x-small left :color="colorProgress(item)">
              fa-circle
            </v-icon>
            {{item.progress}} %
          </v-chip>
        </template>

        <template #item.action="{item, index}">
          <v-btn
            icon
            @click="openEffContractDetailDialog(item)"
          >
            <v-icon small>
              fa-eye
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <the-filter-teachers-list-dialog
        :visible="showFilterDialog"
        @close="showFilterDialog = false"
        @filtered="filteredListTeachers"
        :parent-filters="arraysFilters"
      />
      <the-edit-teacher-order-dialog
        :visible="showEditOrderDialog"
        @close="showEditOrderDialog = false"
        :teachers-list="selectedTeachers"
      />
    </v-sheet>
  </loading>
</template>

<style scoped>

</style>